<template>
    <div>
        <hr/>

        <transition name="fade" mode="out-in">
            <b-field horizontal :label="label">
              <b-input type="number" min="0" max="99" required
                v-model.number="personsNumber"
                :placeholder="localPlaceholder"
              />
            </b-field>
        </transition>

        <template v-for="n in personsNumber">
            <transition name="fade" mode="out-in" :key="`dir_${n}`">
                <b-field horizontal
                  :label="`${labelSingle} ${n} Name`"
                >
                  <b-input type="text" required v-model.trim="localPersons[n-1]"/>
                </b-field>
            </transition>
        </template>
    </div>
</template>

<script>
export default {
  name: 'MultiplePersonsField',
  props: ['label', 'labelSingle', 'listPersons', 'placeholder'],
  data () {
    return {
      localPlaceholder: this.placeholder,
      localPersons: this.listPersons,
      personsNumber: null
    }
  },
  watch: {
    listPersons () {
      this.localPersons = this.listPersons
    },
    placeholder () {
      this.localPlaceholder = this.placeholder
    }
  }
}
</script>

<style scoped>

</style>
